import React from "react";
import './pdfStyle.css'

export default class ComponentToPrint extends React.Component {
    render() {

        const reportData = (this.props.reportData).slice();;
        const selectedSearchValues = this.props.selectedSearchValues;
        const totalValues = this.props.totalValues;
        const chunkedData = this.chunkArray(reportData, 31);

        const formatMonth = (month) => {
            const [year, monthDigits] = month.split("-");
            const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
            const monthName = monthNames[parseInt(monthDigits, 10) - 1];

            return `${monthName} ${year}`;
        };

        const getCrop = (row) => {
            const estateCrop = row.estateCrop;
            const cashKilo = row.cashKilo;
            const outSource = row.outSource;
            const boughtCrop = row.boughtCrop;
            const newEstateCrop = Math.max(0, Math.floor(estateCrop - cashKilo - outSource));
            const total = Math.floor(newEstateCrop + cashKilo + outSource + boughtCrop);

            return total;
        }

        const getEstateCrop = (row) => {
            const estateCrop = row.estateCrop;
            const cashKilo = row.cashKilo;
            const outSource = row.outSource;
            const newEstateCrop = Math.floor(Math.max(0, estateCrop - cashKilo - outSource));

            return newEstateCrop;
        }

        const getAveragePerPlucker = (row) => {
            const estateCrop = getEstateCrop(row);
            const generalPluckers = row.generalPluckers;
            const averagePerPlucker = estateCrop / generalPluckers;

            return averagePerPlucker;
        }


        const getMadeTea = (row) => {
            const madeTea = getCrop(row) / 100 * 22.5;
            return madeTea;
        }


        return (
            <div style={{ width: '100%', marginTop: -60 }}>
                {chunkedData.map((chunk, index) => (
                    <div className="pdf-head">
                        <h6 style={{ color: "black !important" }}>{selectedSearchValues.group} - {selectedSearchValues.estate}</h6>
                        <h6 style={{ color: "black !important" }}>Daily Crop Summary - TEA</h6>
                        <h6 style={{ color: "black !important" }}>
                            Report Month :  <span style={{ fontWeight: "bold" }}> {formatMonth(selectedSearchValues.month)}</span>
                        </h6>

                        <div className="pdf-root">
                            <table className="data-table" id="data-table">
                                <thead>
                                    <tr>
                                        <th rowspan="2">Date</th>
                                        <th colSpan="7">Green Leaf Details</th>
                                        <th rowspan="2">Made <br /> Tea <br /> (Kgs)</th>
                                        <th rowspan="2">Man days<br />of Checkroll<br /> Pluckers</th>
                                        <th rowspan="2">Average <br /> per <br />Plucker</th>
                                        <th rowspan="2">Rainfall <br /> (mm)</th>
                                    </tr>
                                    <tr>
                                        <th>Estate <br />Crop (Kgs)</th>
                                        <th>Cash Kilos</th>
                                        <th>Outsource <br /> Crop (Kgs)</th>
                                        <th>Total Estate <br /> Crop (Kgs)</th>
                                        <th>Bought <br /> Crop (Kgs)</th>
                                        <th>Marginal <br /> Crop</th>
                                        <th>Total Crop <br />(Kgs)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {chunk.map((row, index) => (
                                        <tr key={index}>
                                            <td style={{ width: '20px', textAlign: 'center' }}>{row.day}</td>
                                            <td style={{ width: '50px', textAlign: 'right' }}>
                                                {isNaN(getEstateCrop(row)) ? '-' : getEstateCrop(row)}
                                            </td>
                                            <td style={{ width: '50px', textAlign: 'right' }}>{isNaN(Math.floor(row.cashKilo)) ? '-' : Math.floor(row.cashKilo)}</td>
                                            <td style={{ width: '50px', textAlign: 'right' }}> {isNaN(Math.floor(row.outSource)) ? '-' : Math.floor(row.outSource)}</td>
                                            <td style={{ width: '70px', textAlign: 'right' }}>{isNaN(row.estateCrop) ? '-' : Math.floor(row.estateCrop)}</td>
                                            <td style={{ width: '50px', textAlign: 'right' }}>{row.boughtCrop !== undefined ? Math.floor(row.boughtCrop).toLocaleString() : '-'}</td>
                                            <td style={{ width: '50px', textAlign: 'right' }}>{/*Marginal Crop*/}</td>
                                            <td style={{ width: '50px', textAlign: 'right' }}>
                                                {isNaN(getCrop(row)) ? '-' : getCrop(row)}
                                            </td>

                                            <td style={{ width: '50px', textAlign: 'right' }}>
                                                {
                                                    isNaN((getMadeTea(row)).toFixed(2))
                                                        ? '-'
                                                        : (getMadeTea(row)).toFixed(2).toLocaleString()
                                                }
                                            </td>

                                            <td style={{ width: '50px', textAlign: 'right' }}>{row.generalPluckers}</td>
                                            <td style={{ width: '50px', textAlign: 'right' }}>
                                                {
                                                    isNaN(getAveragePerPlucker(row)) || !isFinite(getAveragePerPlucker(row)) ?
                                                        ' - ' : getAveragePerPlucker(row).toFixed(2)
                                                }
                                            </td>
                                            <td style={{ width: '50px', textAlign: 'right' }}>
                                                {index < 21 && row.rainfall !== undefined ? (row.rainfall.toFixed(2) == 0 ? '-' : row.rainfall.toFixed(2)) : '-'}
                                            </td>

                                        </tr>
                                    ))}
                                    <tr>
                                        <tr>
                                            <td><b>Total</b></td>
                                            <td style={{ textAlign: 'right' }}>{Math.floor(totalValues.totalEstateCrop).toLocaleString()}</td>
                                            <td style={{ textAlign: 'right' }}>{Math.floor(totalValues.totalCashKilo).toLocaleString()}</td>
                                            <td style={{ textAlign: 'right' }}>{Math.floor(totalValues.totalOutSource).toLocaleString()}</td>
                                            <td style={{ textAlign: 'right' }}>{Math.floor(totalValues.totalECrop).toLocaleString()}</td>
                                            <td style={{ textAlign: 'right' }}>
                                                {Math.floor(totalValues.totalBoughtCrop).toLocaleString()}
                                            </td>

                                            <td style={{ textAlign: 'right' }}>{/*total marginal*/}</td>
                                            <td style={{ textAlign: 'right' }}>
                                                {Math.floor(totalValues.totalCrop).toLocaleString()}
                                            </td>

                                            <td style={{ textAlign: 'right' }}>{totalValues.totalMadeTea.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
                                            <td style={{ textAlign: 'right' }}>{totalValues.totalGeneralPluckers.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
                                            <td style={{ textAlign: 'right' }}>{isNaN(totalValues.totalAveragePluckers) ? (0).toFixed(2) : totalValues.totalAveragePluckers.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
                                            <td style={{ textAlign: 'right' }}>{totalValues.totalRainfall.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
                                        </tr>

                                    </tr>
                                    <tr>
                                        <td style={{ width: "'50px'" }}>VP Extent</td>
                                        <td style={{ width: "'50px'" }}></td>
                                        <td style={{ width: "'50px'" }}></td>
                                        <td style={{ width: "'50px'" }}></td>
                                        <td style={{ width: "'50px'" }}></td>
                                        <td style={{ width: "'50px'" }}></td>
                                        <td style={{ width: "'50px'" }}></td>
                                        <td style={{ width: "'50px'" }}></td>
                                        <td style={{ width: "'50px'" }}></td>
                                        <td style={{ width: "'50px'" }}></td>
                                        <td style={{ width: "'50px'" }}></td>
                                        <td style={{ width: "'50px'" }}></td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: "'50px'" }}>Seedling <br /> Extent</td>
                                        <td style={{ width: "'50px'" }}></td>
                                        <td style={{ width: "'50px'" }}></td>
                                        <td style={{ width: "'50px'" }}></td>
                                        <td style={{ width: "'50px'" }}></td>
                                        <td style={{ width: "'50px'" }}></td>
                                        <td style={{ width: "'50px'" }}></td>
                                        <td style={{ width: "'50px'" }}></td>
                                        <td style={{ width: "'50px'" }}></td>
                                        <td style={{ width: "'50px'" }}></td>
                                        <td style={{ width: "'50px'" }}></td>
                                        <td style={{ width: "'50px'" }}></td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: "'50px'" }}>Total <br /> Extent</td>
                                        <td style={{ width: "'50px'" }}></td>
                                        <td style={{ width: "'50px'" }}></td>
                                        <td style={{ width: "'50px'" }}></td>
                                        <td style={{ width: "'50px'" }}></td>
                                        <td style={{ width: "'50px'" }}></td>
                                        <td style={{ width: "'50px'" }}></td>
                                        <td style={{ width: "'50px'" }}></td>
                                        <td style={{ width: "'50px'" }}></td>
                                        <td style={{ width: "'50px'" }}></td>
                                        <td style={{ width: "'50px'" }}></td>
                                        <td style={{ width: "'50px'" }}></td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: "'50px'" }}>Out grower <br />  Extent</td>
                                        <td style={{ width: "'50px'" }}></td>
                                        <td style={{ width: "'50px'" }}></td>
                                        <td style={{ width: "'50px'" }}></td>
                                        <td style={{ width: "'50px'" }}></td>
                                        <td style={{ width: "'50px'" }}></td>
                                        <td style={{ width: "'50px'" }}></td>
                                        <td style={{ width: "'50px'" }}></td>
                                        <td style={{ width: "'50px'" }}></td>
                                        <td style={{ width: "'50px'" }}></td>
                                        <td style={{ width: "'50px'" }}></td>
                                        <td style={{ width: "'50px'" }}></td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: "'50px'" }}>YPH</td>
                                        <td style={{ width: "'50px'" }}></td>
                                        <td style={{ width: "'50px'" }}></td>
                                        <td style={{ width: "'50px'" }}></td>
                                        <td style={{ width: "'50px'" }}></td>
                                        <td style={{ width: "'50px'" }}></td>
                                        <td style={{ width: "'50px'" }}></td>
                                        <td style={{ width: "'50px'" }}></td>
                                        <td style={{ width: "'50px'" }}></td>
                                        <td style={{ width: "'50px'" }}></td>
                                        <td style={{ width: "'50px'" }}></td>
                                        <td style={{ width: "'50px'" }}></td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: "'50px'" }}>Last Year</td>
                                        <td style={{ width: "'50px'" }}></td>
                                        <td style={{ width: "'50px'" }}></td>
                                        <td style={{ width: "'50px'" }}></td>
                                        <td style={{ width: "'50px'" }}></td>
                                        <td style={{ width: "'50px'" }}></td>
                                        <td style={{ width: "'50px'" }}></td>
                                        <td style={{ width: "'50px'" }}></td>
                                        <td style={{ width: "'50px'" }}></td>
                                        <td style={{ width: "'50px'" }}></td>
                                        <td style={{ width: "'50px'" }}></td>
                                        <td style={{ width: "'50px'" }}></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        {chunkedData.length - 1 !== index ? <div className='pagebreak'></div> : <div></div>}
                    </div>
                ))}
            </div>
        );
    }
    chunkArray(array, size) {
        for (let i = array.length % size; i < 31; i++) {
            array.push({ empty: true })
        }
        const chunkedArr = [];
        let index = 0;
        while (index < array.length) {
            chunkedArr.push(array.slice(index, size + index));
            index += size;
        }
        return chunkedArr;
    }
}